import { SearchInput } from '@carsys/ui'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import Clear from '@mui/icons-material/Clear'
import { Box } from '@mui/material'

export interface SearchFilterProps {
  name: string
  setFilter: (value: any) => void
  filter: string
  placeholder: string
}

export const SearchFilter = ({ name, setFilter, filter, placeholder }: SearchFilterProps) => {
  return (
    <Box>
      <SearchInput
        name={name}
        placeholder={placeholder}
        variant='standard'
        size='small'
        autoComplete='off'
        onChange={e => setFilter(e.target.value)}
        value={filter}
        data-testid='selection-search'
        inputProps={{
          autoFocus: true,
          endAdornment: <InputAdornment position='end' />
        }}
      />
      {filter && (
        <IconButton disabled={!filter} size='small' onClick={() => setFilter('')}>
          <Clear />
        </IconButton>
      )}
    </Box>
  )
}
